import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
} from "chart.js";
import { DASHBOARD_PALETTE } from "../../utils/palette.token";
import { ITransactionChart } from "./type";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    intersect: false,
    mode: "index" as const,
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: DASHBOARD_PALETTE.surfaceElevated,
      titleColor: DASHBOARD_PALETTE.textPrimary,
      bodyColor: DASHBOARD_PALETTE.textSecondary,
      borderColor: DASHBOARD_PALETTE.borderAccent,
      borderWidth: 1,
      padding: 12,
      cornerRadius: 8,
      displayColors: false,
    },
  },
  scales: {
    x: {
      grid: {
        color: DASHBOARD_PALETTE.chartGridLine,
        drawBorder: false,
      },
      ticks: {
        color: DASHBOARD_PALETTE.muted,
        font: {
          family: "Montserrat",
          size: 11,
        },
        maxRotation: 0,
      },
    },
    y: {
      grid: {
        color: DASHBOARD_PALETTE.chartGridLine,
        drawBorder: false,
      },
      ticks: {
        color: DASHBOARD_PALETTE.muted,
        font: {
          family: "Montserrat",
          size: 11,
        },
      },
    },
  },
  elements: {
    line: {
      tension: 0.4,
    },
    point: {
      radius: 0,
      hoverRadius: 6,
      hoverBackgroundColor: DASHBOARD_PALETTE.accent,
      hoverBorderColor: "#fff",
      hoverBorderWidth: 2,
    },
  },
};

const TransactionChart = ({ data }: ITransactionChart) => {
  const labels = data ? Object.keys(data) : [];

  const dataChart = {
    labels,
    datasets: [
      {
        fill: true,
        label: "Transactions",
        data: data ? Object.values(data) : [],
        borderColor: DASHBOARD_PALETTE.accent,
        backgroundColor: (context: any) => {
          const ctx = context.chart.ctx;
          const gradient = ctx.createLinearGradient(0, 0, 0, 250);
          gradient.addColorStop(0, "rgba(110, 200, 240, 0.22)");
          gradient.addColorStop(1, "rgba(110, 200, 240, 0)");
          return gradient;
        },
        borderWidth: 2,
      },
    ],
  };

  return <Line options={options} data={dataChart} />;
};

export default TransactionChart;
